import { useReactiveVar } from '@apollo/client'
import { labelCodeIdVar, spaceIdVar } from 'modulesCommon/store'
import { useZonesList } from 'modulesCommon/serviceHooks'

const useZoneTag = (labelId?: string | null) => {
  const { zoneList } = useZonesList()
  const labelCodeId = useReactiveVar(labelCodeIdVar)
  const spaceId = useReactiveVar(spaceIdVar)

  const projectLabel = zoneList.find((label) => {
    if (!labelId || !label.id) {
      return null
    }
    return +label.id === +labelId
  })

  const isSameLabel = labelCodeId === projectLabel?.id

  return {
    isSpace: !!spaceId,
    isSameLabel,
    label: projectLabel
  }
}

export default useZoneTag
